// src/config.js
export const API = 'https://api.brotecolectivo.com';
export const SITE_URL = 'https://www.brotecolectivo.com';
export const TOKEN = 'token-secreto';
export const MEDIA_URL = 'https://brotecolectivo.sfo3.cdn.digitaloceanspaces.com/';
